/**
 * Geometry of the panorama editor's chrome. The photo runs from the left edge
 * to the right panel; the top bar, the tool palette, the help button and the
 * thumbnail dock float over it, so everything drawn on the photo (tool bars,
 * toasts, the card being edited) starts below / beside them.
 */

/** Gap between the window edge, the floating layers and the HUD. */
export const EDITOR_EDGE_GAP = 12;

/** Height of the floating top bar (32px buttons + 6px rim, like the palette). */
export const EDITOR_TOP_BAR_HEIGHT = 44;

/**
 * Where the top bar ends. "Ver como visitante" (client-preview.tsx, visitor
 * zone, untouched) starts at `top-14` = 56px: the bar must end there exactly.
 */
export const EDITOR_TOP_BAR_BOTTOM = EDITOR_EDGE_GAP + EDITOR_TOP_BAR_HEIGHT;

/** Top of the HUD drawn on the photo (tool bars, HD indicator): below the bar. */
export const EDITOR_HUD_TOP = EDITOR_TOP_BAR_BOTTOM + EDITOR_EDGE_GAP;

/** Rounded left corners of the right panel; the photo runs under them. */
export const EDITOR_PANEL_RADIUS = 13;

/** Bottom reserve when the dock is collapsed (its tab) or absent. */
export const EDITOR_HUD_BOTTOM_MIN = 20;

/**
 * Space the bottom tool bars leave free, from the dock's top edge measured
 * from the photo's bottom (null: no dock on screen).
 */
export function editorHudBottom(dockTop: number | null): number {
  return Math.max(EDITOR_HUD_BOTTOM_MIN, Math.round(dockTop ?? 0));
}
